var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-modal', {
    ref: "modal",
    attrs: {
      "centered": "",
      "no-close-on-backdrop": "",
      "no-fade": "",
      "hide-footer": ""
    },
    on: {
      "close": _vm.cancel
    },
    scopedSlots: _vm._u([{
      key: "modal-title",
      fn: function fn() {
        return [_c('div', {
          staticClass: "title"
        }, [_vm._v(_vm._s(_vm.tt(_vm.title)))])];
      },
      proxy: true
    }])
  }, [[_c('div', {
    staticClass: "body"
  }, [_vm.isCanCount ? _c(_vm.categoryByInput, {
    tag: "component",
    attrs: {
      "volume": _vm.volume,
      "volumeUnit": _vm.volumeUnit,
      "useCount": _vm.useCount
    },
    on: {
      "input": function input(volume) {
        return _vm.setUseVolume(volume);
      }
    }
  }) : _vm._e(), _c('div', {
    staticClass: "reason-wrap"
  }, [_c('div', {
    staticClass: "input-head-text"
  }, [_c('p', [_vm._v(_vm._s(_vm.tt('사용 사유')))]), _c('p', {
    staticClass: "text-length"
  }, [_c('span', {
    staticClass: "length",
    "class": {
      over: _vm.isLengthOver
    }
  }, [_vm._v(" " + _vm._s(_vm.reason.length) + " ")]), _vm._v("/" + _vm._s(_vm.textMaxLength) + " ")])]), _c('div', {
    directives: [{
      name: "click-outside",
      rawName: "v-click-outside",
      value: _vm.focusOut,
      expression: "focusOut"
    }]
  }, [_c('textarea', {
    staticClass: "input-reason",
    "class": {
      error: _vm.isShowReasonError && _vm.isLengthOver
    },
    attrs: {
      "placeholder": _vm.tt("\uC0AC\uC6A9 \uC0AC\uC720\uB97C \uC785\uB825\uD574\uC8FC\uC138\uC694(".concat(_vm.textMaxLength, "\uC790 \uC81C\uD55C)"))
    },
    domProps: {
      "value": _vm.formattedReason
    },
    on: {
      "input": function input(e) {
        return _vm.setReason(e.target.value);
      },
      "focus": function focus($event) {
        _vm.isFocus = true;
      }
    }
  }), _vm._v(" "), _vm.isShowReasonError && _vm.isLengthOver ? _c('p', {
    staticClass: "error-msg"
  }, [_c('img', {
    attrs: {
      "src": require("@/views/inventoryGen2/components/svg/icon-error.svg")
    }
  }), _vm._v(" " + _vm._s(_vm.tt('글자수를 초과하였습니다.')) + " ")]) : _vm._e(), _c('recent', {
    ref: "recent",
    attrs: {
      "show": _vm.isKeywordWrapperOpen,
      "list": _vm.commentList
    },
    on: {
      "clickComment": _vm.clickComment,
      "deleteComment": _vm.clickDeleteComment
    }
  })], 1)])], 1), _c('div', {
    staticClass: "modal-footer-wrap"
  }, [_c('button', {
    staticClass: "button-white",
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v(" " + _vm._s(_vm.tt(_vm.cancelText)) + " ")]), _c('button', {
    "class": "button-".concat(_vm.variant),
    on: {
      "click": _vm.confirm
    }
  }, [_vm._v(" " + _vm._s(_vm.tt(_vm.confirmText)) + " ")])])]], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }